import { Link, route } from 'preact-router';
import { Component } from 'preact';

import SearchIconWhite from '../../assets/icons/searchWhite.svg';
import SearchIcon from '../../assets/icons/searchBlue.svg';
import { API } from '../API/index.js';

import HeaderButton from './components/headerButton';
import Search from './components/search.js';

import style from './style.scss';
import searchStyling from '../header/components/search.scss';
import headerStyling from '../header/components/headerButton.scss';

import { checkForIos } from '../../utils/checkForIos';
import { changeFlexForMobile } from '../../utils/changeFlexForMobile';
import { changeHeaderTheme } from '../../utils/changeHeaderTheme';

var location = window.location.hash;
var selectedAudiencesId = {};
var selectedInsightsId = {};
var selectedCollabsId = {};
var selectedGetInTouchId = {};
class Header extends Component {
	constructor(props) {
		super(props);

		this.state = {
			headerToggle   : false,
			hamLineColor   : '',
			gdpLogo        : '',
			openHeaderDrop : false,
			openSearch     : false
		};
		const self = this;
		this.handleSearchOpen = this.handleSearchOpen.bind(this);
	}

	componentDidMount() {}

	componentWillReceiveProps(nextProps) {}

	componentDidUpdate() {
		location = window.location.hash;

		if (location === '#/audiences') {
			document.getElementById('nav-audience').style.fontFamily = 'Gotham-Black';
			document.getElementById('nav-insight').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-collab').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-getintouch').style.fontFamily = 'Gotham-Medium';
		}
		else if (location === '#/insights') {
			document.getElementById('nav-audience').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-insight').style.fontFamily = 'Gotham-Black';
			document.getElementById('nav-collab').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-getintouch').style.fontFamily = 'Gotham-Medium';
		}
		else if (location === '#/collabs') {
			document.getElementById('nav-audience').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-insight').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-collab').style.fontFamily = 'Gotham-Black';
			document.getElementById('nav-getintouch').style.fontFamily = 'Gotham-Medium';
		}
		else if (location === '#/getintouch') {
			document.getElementById('nav-audience').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-insight').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-collab').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-getintouch').style.fontFamily = 'Gotham-Black';
		}
		else {
			document.getElementById('nav-audience').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-insight').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-collab').style.fontFamily = 'Gotham-Medium';
			document.getElementById('nav-getintouch').style.fontFamily = 'Gotham-Medium';
		}
	}

	shouldComponentUpdate() {
		return true;
	}

	styleHeader() {
		var logo = document.getElementsByClassName(style.logoMobile)[0];
		logo.src = '/assets/logos/gdp-logo.png';
		document.getElementsByClassName(style.headerLine)[0].style.background = '#004b80';
		document.getElementsByClassName(style.headerLine)[1].style.background = '#004b80';
		document.getElementsByClassName(style.headerLine)[2].style.background = '#004b80';
		document.getElementsByClassName(style.mobileViewHeader)[0].style.background = '#eee';
	}

	handleDropdown = () => {
		let { openHeaderDrop } = this.state;

		this.setState({ openHeaderDrop: !openHeaderDrop }, () => {
			changeFlexForMobile(openHeaderDrop, headerStyling.icons, 0);
		});
	};

	handleSearchOpen() {
		let { openSearch } = this.state;
		this.setState({ openSearch: !openSearch }, () => {
			changeFlexForMobile(openSearch, headerStyling.icons, 1);
			setTimeout(() => {
				if (checkForIos() && !openSearch) {
					// document.getElementById('header-drop-open').style.display = 'none';
					let element = document.getElementById('search-container');
					element.classList.add(searchStyling.searchContainer);
					document.getElementById('app').classList.add('no-scroll');
				}
			}, 50);
			if (checkForIos() && openSearch) {
				// document.getElementById('header-drop-open').style.display = 'flex';
				document.getElementById('app').classList.remove('no-scroll');
			}
		});
	}

	render() {
		const { openHeaderDrop, openSearch } = this.state;

		var originalHomeTop = document.getElementById('app').scrollTop > 0;
		var logo = '';
		var search = '';

		if (
			!openHeaderDrop &&
			!originalHomeTop &&
			(location === '#/' || location === '#/insights' || location === '#/audiences')
		) {
			logo = 'gdp-logo';
			search = SearchIconWhite;
		}
		else if (!originalHomeTop && !openHeaderDrop) {
			logo = 'blueconnect';
			search = SearchIcon;
		}
		else {
			logo = 'blueconnect';
			search = SearchIcon;
		}

		let InsightsButton = (isMobile = false) => {
			return (
				<Link
					id="nav-insight"
					class={[
						openHeaderDrop ? style.navOptionsOverlay : style.navOptions,
						isMobile ? style.mobileVersion : ''
					].join(' ')}
					onClick={() => {
						route('/insights');
					}}
				>
					Insights
				</Link>
			);
		};

		let AudiencesButton = (isMobile = false) => {
			return (
				<Link
					id="nav-audience"
					class={[
						openHeaderDrop ? style.navOptionsOverlay : style.navOptions,
						isMobile ? style.mobileVersion : ''
					].join(' ')}
					onClick={() => {
						route('/audiences');
					}}
				>
					Audiences
				</Link>
			);
		};

		let CollabsButton = (isMobile = false) => {
			return (
				<Link
					id="nav-collab"
					class={[
						openHeaderDrop ? style.navOptionsOverlay : style.navOptions,
						isMobile ? style.mobileVersion : ''
					].join(' ')}
					onClick={() => {
						route('/collabs');
					}}
				>
					Collabs
				</Link>
			);
		};

		let GetInTouchButton = (isMobile = false) => {
			return (
				<Link
					id="nav-getintouch"
					class={[
						openHeaderDrop ? style.navOptionsOverlay : style.navOptions,
						isMobile ? style.mobileVersion : ''
					].join(' ')}
					onClick={() => {
						route('/getintouch');
					}}
				>
					TALK TO US
				</Link>
			);
		};

		let CorporateButton = (isMobile = false) => {
			return (
				<Link
					style={selectedGetInTouchId}
					class={[
						openHeaderDrop ? style.navOptionsOverlay : style.navOptions,
						isMobile ? style.mobileVersion : ''
					].join(' ')}
					onClick={() => {
						window.open('http://venture.dev365.gdpventure.com/#/', '_blank');
					}}
				>
					CORPORATE
				</Link>
			);
		};

		return (
			<section
				class={[
					style.mainHeaderContainer,
					openHeaderDrop ? style.dropHeader : ''
				].join(' ')}
			>
				<div class={style.headerContainer} id="header-container">
					<div class={style.logoContainer}>
						<Link
							onClick={() => {
								route('/');
							}}
						>
							<img style="cursor:pointer" src={`/assets/logos/${logo}.png`} id="main-logo" />
						</Link>
					</div>
					<div class={style.navContainer}>
						{!openHeaderDrop && CollabsButton(true)}
						{!openHeaderDrop && InsightsButton(true)}
						{!openHeaderDrop && AudiencesButton(true)}
						{!openHeaderDrop && GetInTouchButton(true)}
						{!openHeaderDrop && CorporateButton(true)}
						<div
							className={openHeaderDrop ? style.mobileSearchIconAnimate : ''}
							onClick={this.handleSearchOpen}
						>
							<img id="search-icon" src={search} style="padding-right:0rem" />
						</div>
						<div onClick={this.handleDropdown}>
							<HeaderButton dropOpen={openHeaderDrop} />
						</div>
					</div>
				</div>
				{openSearch && <Search handleSearchModel={this.handleSearchOpen} />}
				{openHeaderDrop && (
					<div className={style.dropdownData}>
						{CollabsButton()}
						{InsightsButton()}
						{AudiencesButton()}
						{GetInTouchButton()}
						{CorporateButton()}

						<div style={{ padding: '1rem' }} />
						<div class={style.socialConnect}>
							<div style={'display:flex'}>
								<a href="https://www.facebook.com/GDPVenture/" target="_blank">
									<img src="/assets/images/Facebook_blue.svg" />
								</a>
								<a href="https://twitter.com/gdpventure?s=09" target="_blank">
									<img src="/assets/images/Twitter_blue.svg" />
								</a>
							</div>
							<div>
								<p>&copy; GDP Venture All Rights Reserved.</p>
							</div>
						</div>
					</div>
				)}
			</section>
		);
	}
	modalFire = () => {
		if (this.state.headerToggle === true) {
			var headerLine = document.getElementsByClassName(style.headerLine)[0];
			var compStyle = window.getComputedStyle(headerLine);
			this.setState({
				hamLineColor : compStyle.getPropertyValue('background-color'),
				gdpLogo      : document.getElementsByClassName(style.logoMobile)[0].src
			});
			document.getElementsByClassName(style.headerHamButton)[0].classList.add(style.close);
			document.getElementsByClassName(style.menu)[0].classList.add(style.show);
			var nav = document.getElementsByClassName(style.navItem);
			for (var i = 0; i < nav.length; i++) {
				nav[i].classList.add(style.show);
			}
			document.getElementsByClassName(style.socialConnect)[0].classList.add(style.show);
			var lines = document.getElementsByClassName(style.headerLine);
			for (var i = 0; i < lines.length; i++) {
				lines[i].style.background = 'white';
			}
			document.getElementsByClassName(style.logoMobile)[0].src = 'assets/images/gdp logo white@2x.png';
			document.getElementById('app').setAttribute('overflow:hidden');
		}
		else {
			document.getElementsByClassName(style.headerHamButton)[0].classList.remove(style.close);
			document.getElementsByClassName(style.menu)[0].classList.remove(style.show);
			var nav = document.getElementsByClassName(style.navItem);
			for (var i = 0; i < nav.length; i++) {
				nav[i].classList.remove(style.show);
			}
			document.getElementsByClassName(style.socialConnect)[0].classList.remove(style.show);
			var lines = document.getElementsByClassName(style.headerLine);
			for (var i = 0; i < lines.length; i++) {
				lines[i].style.background = this.state.hamLineColor;
			}
			document.getElementById('app').setAttribute('overflow:visible');
			document.getElementsByClassName(style.logoMobile)[0].src = this.state.gdpLogo;
		}
	};
}

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js